import MyButton from '../buttons'
import { AlbumType } from './types/models'
import {
  FaCheck,
  FaTimes,
  FaTrash,
  FaFolderPlus,
  FaFolderMinus,
} from 'react-icons/fa'

interface GalleryActionButtonsProps {
  onSelectAll: () => void
  onDeselectAll: () => void
  onRemoveFromAlbum?: () => void
  onDelete?: () => void
  onAddToAlbum?: () => void
  selectedCount: number
  t: (key: string) => string
  isAlbumView?: boolean
  albumType?: AlbumType
}

const GalleryActionButtons: React.FC<GalleryActionButtonsProps> = ({
  onSelectAll,
  onDeselectAll,
  onRemoveFromAlbum,
  onDelete,
  onAddToAlbum,
  selectedCount,
  t,
  isAlbumView,
  albumType = 'announce',
}) => {
  const albumName = t(`album-${albumType}`)
  const buttonCount = 1 + (selectedCount > 0 ? (isAlbumView ? 2 : 3) : 0)

  return (
    <div className='flex justify-center'>
      <div
        className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-1 py-0 px-0 rounded-lg w-full ${
          buttonCount === 1 ? 'justify-center' : ''
        }`}
      >
        <MyButton
          variant='darkgray'
          onClick={(e: { preventDefault: () => void }) => {
            e.preventDefault()
            onSelectAll()
          }}
          className='text-sm px-3 py-1.5 w-full sm:w-auto flex-1 flex items-center justify-center gap-2'
        >
          <FaCheck className='w-4 h-4' />
          {t('select-all')}
        </MyButton>

        {selectedCount > 0 && (
          <>
            <MyButton
              variant='darkgray'
              onClick={(e: { preventDefault: () => void }) => {
                e.preventDefault()
                onDeselectAll()
              }}
              className='text-sm px-3 py-1.5 w-full sm:w-auto flex-1 flex items-center justify-center gap-2'
            >
              <FaTimes className='w-4 h-4' />
              {t('deselect-all')}
            </MyButton>

            {isAlbumView ? (
              <MyButton
                variant='redpink'
                onClick={(e: { preventDefault: () => void }) => {
                  e.preventDefault()
                  onRemoveFromAlbum && onRemoveFromAlbum()
                }}
                className='text-sm px-3 py-1.5 w-full sm:w-auto flex-1 flex items-center justify-center gap-2'
              >
                <FaFolderMinus className='w-4 h-4' />
                {t('remove-from-album')}
              </MyButton>
            ) : (
              <>
                <MyButton
                  variant='redpink'
                  onClick={(e: { preventDefault: () => void }) => {
                    e.preventDefault()
                    onDelete && onDelete()
                  }}
                  className='text-sm px-3 py-1.5 w-full sm:w-auto flex-1 flex items-center justify-center gap-2'
                >
                  <FaTrash className='w-4 h-4' />
                  {t('delete-selected')}
                </MyButton>
                <MyButton
                  variant='green'
                  onClick={(e: { preventDefault: () => void }) => {
                    e.preventDefault()
                    onAddToAlbum && onAddToAlbum()
                  }}
                  className='text-sm px-3 py-1.5 w-full sm:w-auto flex-1 flex items-center justify-center gap-2'
                >
                  <FaFolderPlus className='w-4 h-4' />
                  {t('add-to-album')} {albumName}
                </MyButton>
              </>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default GalleryActionButtons
